/**
 * @typedef {('product' | 'inventory' | 'order' | 'dangerousGoods' | 'scanToReceive' | 'productWithInventory' | 'inventoryLocation' | 'tote' | 'fulfillmentProduct' | 'asn' | 'blacklist' | 'purchaseOrder' | 'supplier' | 'productUom' | 'freight' | 'customPackage')} ImportTypes
 */

/**
 * @type {Record<ImportTypes, ImportTypes>}
 */
export const ImportType = {
  product: 'product',
  fulfillmentProduct: 'fulfillmentProduct',
  inventory: 'inventory',
  order: 'order',
  dangerousGoods: 'dangerousGoods',
  scanToReceive: 'scanToReceive',
  productWithInventory: 'productWithInventory',
  inventoryLocation: 'inventoryLocation',
  tote: 'tote',
  asn: 'asn',
  blacklist: 'blacklist',
  purchaseOrder: 'purchaseOrder',
  supplier: 'supplier',
  productUom: 'productUom',
  freight: 'freight',
  customPackage: 'customPackage',
};

export const ImportTypesValues = Object.values(ImportType);
